var React = require('react');

function Cloud (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.74 10.2A6.86 6.86 0 0 0 5.9 8.37a5.5 5.5 0 0 0 .6 10.96h11.92a4.56 4.56 0 1 0 .32-9.13zm-8.57 6.38l-3.21-3.2 1.3-1.3 1.9 1.9 4.76-4.73 1.29 1.3-6.04 6.03z"}));
}

Cloud.displayName = "Cloud";

Cloud.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Cloud;

Cloud.default = Cloud;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Cloud.svg
// module id = 638
// module chunks = 168707334958949